<template>
	<div>
		<a-row>
			<a-col>
				<label>用户名：</label>
				<span>{{theInfo.customerName}}</span>
			</a-col>
		</a-row>
		<a-row>
			<a-col>
				<label>手机：</label>
				<span>{{theInfo.customerMobile}}</span>
			</a-col>
		</a-row>
		<a-row>
			<a-col>
				<label>身份证：</label>
				<span>{{theInfo.nationalId}}</span>
			</a-col>
		</a-row>
		<a-row>
			<a-col>
				<label>发票备注：</label>
				<span>{{theInfo.fpRemark}}</span>
			</a-col>
		</a-row>
	</div>
</template>

<script>
	export default{
		props:['theInfo'],
		data(){
			return {
				
			}
		},
	}
</script>

<style>
</style>
